import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewKda = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m7.05 13.406 3.534 3.536-1.413 1.414 1.415 1.415-1.414 1.414-2.475-2.475-2.83 2.829-1.413-1.414 2.829-2.83-2.475-2.474 1.414-1.414 1.414 1.413 1.414-1.414ZM3 3l3.546.003 11.817 11.818 1.415-1.414 1.414 1.414-2.474 2.475 2.828 2.829-1.414 1.414-2.83-2.83-2.474 2.476-1.414-1.414 1.414-1.415L3.003 6.53 3 3Zm14.457 0L21 3.003l.002 3.523-4.053 4.052-3.536-3.535L17.457 3Z"
    />
  </svg>
);
